import React from 'react'
import get from 'lodash/get'
import styled, {css} from 'styled-components'
import {
  Grid,
  Paper,
  Select,
  MenuItem,
  Button,
  TextField,
  InputLabel,
} from '@material-ui/core'

const SelectError = styled.div`
  color: red;
  height: 15%;
`

export const GRID_CONTAINER_SPACING = 32

export const baseItemCSS = css`
  padding: 8px 16px;
`

export const GridItem = styled(Grid)`
  ${baseItemCSS};
`

export const SectorContainer = styled(Paper)`
  padding: 16px;
`

export const SaveButton = styled(Button)`
  background: #663ee8;
  color: #f9fdff;
  margin-top: 24px;
`

export const ShippingMediumDefault = [
  'Thaipost-Register',
  'Thaipost-EMS',
  'Kerry',
  'TNT',
  'SCG yamato express',
  'DHL',
  'J&T',
  'Flash express',
]

export const FormikTextField = ({
  errors,
  touched,
  name,
  label,
  required,
  endAdornment,
  ...otherProps
}) => {
  const isError = get(errors, name) && get(touched, name)
  const extraProps = {}
  if (endAdornment) {
    extraProps.InputProps = {
      endAdornment,
    }
  }
  return (
    <TextField
      label={required ? `${label} *` : label}
      error={isError}
      helperText={isError ? get(errors, name) : null}
      name={name}
      {...otherProps}
      {...extraProps}
    />
  )
}

export const FormikSelect = ({
  label,
  lableId = `${label} *`,
  errors,
  touched,
  name,
  required,
  listItems,
  ...otherProps
}) => {
  const isError = get(errors, name) && get(touched, name)
  const labelName = required ? `${label} *` : label
  return (
    <div>
      {label ? <div><InputLabel id={lableId}>{labelName}</InputLabel></div> : null}
      <Select error={isError} name={name} displayEmpty {...otherProps} labelId={lableId}>
        {listItems.map(menuItem => {
          return (
            <MenuItem key={menuItem.value} value={menuItem.value}>
              {menuItem.label}
            </MenuItem>
          )
        })}
      </Select>
      <SelectError>{isError ? get(errors, name) : null}</SelectError>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/components/common.js